module.exports = __webpack_public_path__ + "static/scale-model-of-carolyn-lee-wills-&-associates-in-sandy-springs-georgia-d9b814f71983b5f9d0e0fe70ab956911.png";